import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { MatRadioModule } from "@angular/material/radio";
import { FormsModule } from "@angular/forms";
import { MapV2LoaderComponent } from "./mapv2-loader/mapv2-loader.component";
import { MapV2SectorsComponent } from "./mapv2-sectors/mapv2-sectors.component";
import { StoreModule } from "@ngrx/store";
import { reducers } from "./store";
import { MapV2PlacesComponent } from "./mapv2-places/mapv2-places.component";
import { MapV2TicketsComponent } from "./mapv2-tickets/mapv2-tickets.component";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MapV2CartComponent } from "./mapv2-cart/mapv2-cart.component";
import { MapV2Component } from "./mapv2.component";
import { PlacesBySectorPipe } from "./pipes/places-by-sector.pipe";
import { MapV2Service } from "./mapv2.service";
import { MAP_FEATURE } from "./store/map.actions";

registerLocaleData(localePt);

@NgModule({
  declarations: [
		MapV2Component,
		MapV2SectorsComponent,
		MapV2PlacesComponent,
		MapV2LoaderComponent,
		MapV2TicketsComponent,
		MapV2CartComponent,
		PlacesBySectorPipe
	],
  imports: [
		CommonModule,
		FormsModule,
		MatToolbarModule, 
		MatDialogModule,
		MatIconModule,
		MatButtonModule,
		MatRadioModule,
		MatSidenavModule,
		StoreModule.forFeature(MAP_FEATURE, reducers),
	],
  exports: [MapV2Component],
	entryComponents: [MapV2PlacesComponent],
	providers: [
		MapV2Service,
		{ provide: LOCALE_ID, useValue: 'pt-BR' }
	]
})
export class MapV2Module {}
